import React from "react";
import { toastMessage } from "utils/toastMessage";
import useButtonLoader from "hooks/useButtonLoader";
import { changeStatusUserAPI } from "services/user";
import { PopupModal } from "components/modals/ModalBox";
import { editSubAdminApi } from "services/feedback";

const SubAdminStatusManage = ({
  isBlockModalVisible,
  selectedUserDetail,
  onClose,
  refetchUserList,
}) => {
  // const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");

  // change delete handler
  const changeStatusHandler = async () => {
    try {
      // setButtonLoader(true);
      const reqData = {
        _id: selectedUserDetail?._id || "",
        status: selectedUserDetail?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      const { data: responseData, status } = await editSubAdminApi(reqData);
      if (status === 200) {
        refetchUserList();
        onClose();
        toastMessage(responseData?.message, "success", "changeUserStatus");
      }
    } catch (e) {
      console.log("error:", e);
    } finally {
      // setButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        handleClose={onClose}
        show={isBlockModalVisible}
        title={`Are you sure you want to ${selectedUserDetail?.status === "ACTIVE" ? "block" : "UnBlock"} this sub-admin`}
        children={
          <div className="button_wrap">
            <button type="button" className="button light" onClick={changeStatusHandler}>
              {selectedUserDetail?.status === "ACTIVE" ? "block" : "UnBlock"}
            </button>
            <button
              type="button"
              className="button"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        }
      />
    </>
  );
};

export default SubAdminStatusManage;
